const Switch = ({ value, children }) => {
  return children.find((child) => {
    return child.props.value === value;
  });
};

export default Switch;
